import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../../../base/dialog';
import { Switch } from '../../../base/react';
import { useVisitorsToggle } from './useVisitorsToggle';
/**
 * A standalone, moderator-only dialog (opened from the toolbar) for turning visitor mode on/off,
 * with live visitor count and join-request count. Kept separate from the (deprecated) Security dialog.
 *
 * @returns {JSX.Element}
 */
const VisitorsDialog = () => {
    const { t } = useTranslation();
    const { visible, toggleError, toggleValue, togglePending, onToggleVisitors, visitorsCount, requests } = useVisitorsToggle();
    // Changes apply immediately via the switch; OK/Done just dismisses the dialog.
    const onSubmit = useCallback(() => true, []);
    return (React.createElement(Dialog, { hideCancelButton: true, okKey: 'dialog.done', onSubmit: onSubmit, titleKey: 'visitors.section.title', width: 'small' },
        React.createElement("div", { className: 'visitors-controls' }, visible ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: 'description' }, t('visitors.section.description')),
            React.createElement("div", { className: 'control-row' },
                React.createElement("label", { htmlFor: 'visitors-dialog-switch' }, t('visitors.section.toggleLabel')),
                React.createElement(Switch, { disabled: togglePending, id: 'visitors-dialog-switch', onValueChange: onToggleVisitors, value: toggleValue })),
            (togglePending || toggleError || visitorsCount > 0 || requests.length > 0) && (React.createElement("div", { className: 'visitors-stats' },
                togglePending && React.createElement("span", null, t('visitors.section.pending')),
                toggleError && React.createElement("span", { className: 'visitors-error' }, t(toggleError)),
                visitorsCount > 0
                    && React.createElement("span", null, t('visitors.section.visitorsCount', { count: visitorsCount })),
                requests.length > 0 && (React.createElement("span", { className: 'visitors-requests' }, t('visitors.section.requestsPending', { count: requests.length }))))))) : (React.createElement("p", { className: 'description' }, t('visitors.section.unavailable'))))));
};
export default VisitorsDialog;
